<script setup lang="ts">
</script>

<template>
  <section class="mt-1">
    <div>
      <product-info-bullet />
    </div>
    <div style="min-height: 200px;" class="hidden">
      {{ $t('www.product_content.delivery.select') }}
    </div>
  </section>
</template>
